<template>
	<button
		class="download-btn"
		:disabled="disabled"
		@click="$emit('download-item')"
	>
		<img class="download-btn-img" :src="urlImage" :alt="alt" />
	</button>
</template>

<script>
	export default {
		name: 'download-btn',
		props: {
			alt: String,
			disabled: {
				type: Boolean,
				default: false,
			},
			height: [Number, String],
			urlImage: String,
		},
	};
</script>

<style lang="scss" scoped>
	.download-btn {
		align-items: center;
		background-color: color(white) !important;
		border-radius: 2px !important;
		display: flex;
		height: 45px !important;
		justify-content: center;
		margin-left: 5px;
		width: 45px !important;

		&-img {
			height: 27px !important;
		}

		&:disabled {
			cursor: not-allowed;
			opacity: 0.5;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/diagnosis/download-btn.vue